import React, { useState } from 'react'
import emailjs from "@emailjs/browser"
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const ContactUs = () => {
    const [show, setShow] = useState(false);
    const sendEmail = (e) => {
        e.preventDefault()
        emailjs.sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLETE_ID, e.target, process.env.REACT_APP_PUBLIC_KEY)
        .then(() => handleShow())
        .catch(err => console.err("Error", err))
    }

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
    return (
        <>
            
            <form onSubmit={sendEmail}>
                <div className="p-2 mx-1">
                <div className="col-lg-12">
                        <div className="form-group mt-2">
                            <input className="form-control-footer" name="name" type="text"  placeholder="Your Name" />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-group mt-2">
                            
                            <input className="form-control-footer" name="phone" type="tel"  placeholder="Phone Number" />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-group mt-2">
                            
                            <input className="form-control-footer" name="company_name" type="text"  placeholder="Company Name" />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-group mt-2">
                            
                            <input className="form-control-footer" name="email" type="text"  placeholder="Email" />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-group mt-2">
                            
                            <textarea className="form-control-footer" name="message" rows="3" placeholder="Type your message here"></textarea>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <button type="submit" className="btn btn-primary send-button mt-3 w-100 text-white border-0 px-2 py-2"><FontAwesomeIcon icon={faPaperPlane} className="px-2 icon-color-font"/> SEND</button>
                    </div>
                    <br />
                </div>
            </form>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <p className="py-4">Congratulations ! </p> 
                    <p>Your message has been sent successfully!</p> 
                </Modal.Header>
            </Modal>
            
        </>
    )
}

export default ContactUs